import React from "react";

function XIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            fill="none"
            viewBox="0 0 25 24"
        >
            <circle cx="12.014" cy="12" r="9.6" fill="#fff"></circle>
            <path
                fill="#D0D0D0"
                d="M12.065 24c-1.707 0-3.294-.305-4.76-.915a11.765 11.765 0 01-3.827-2.535 11.708 11.708 0 01-2.545-3.81C.32 15.28.013 13.7.013 12c0-1.68.307-3.25.92-4.71a11.708 11.708 0 012.545-3.81A11.966 11.966 0 017.305.93C8.77.31 10.358 0 12.065 0c1.687 0 3.264.31 4.73.93 1.466.62 2.741 1.47 3.826 2.55a11.908 11.908 0 012.56 3.81c.623 1.46.935 3.03.935 4.71 0 1.7-.312 3.28-.934 4.74a11.908 11.908 0 01-2.561 3.81 11.765 11.765 0 01-3.826 2.535c-1.467.61-3.043.915-4.73.915zm-4.52-6.24l4.52-4.5 4.519 4.5 1.265-1.26L13.33 12l4.52-4.5-1.266-1.26-4.52 4.5-4.518-4.5L6.28 7.5 10.8 12l-4.52 4.5 1.266 1.26z"
            ></path>
        </svg>
    );
}

export default XIcon;
